import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useCSMGetAll } from '../../../api/csm';
import { FlexView, Row, Separator } from '@cuemath/comps';
import { Table, TableCell } from 'comps';
import { TableRow } from 'semantic-ui-react';
import styled, { keyframes } from 'styled-components';
import { Text } from '@cuemath/web-comps';
import Search from 'modules/list/new-search-bar';
import LAYOUT from 'constants/layout';
import { getUserFullName } from 'utils';

const StyledTableCell = styled(TableCell)`
  cursor: pointer;
`;
const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const Container = styled(FlexView)`
  padding: 0 ${LAYOUT.GUTTER}px;
  animation: ${FadeIn} 0.5s ease-in-out;
`;

const TableWrapper = styled(Row)`
  margin-top: 24px;
  width: 100%;
`;

const CSM = () => {
  const {
    data: listOfCSM,
    getAll: getListOfCSM,
    isProcessing: isLoading,
  } = useCSMGetAll();
  const [search, setSearch] = useState('');

  const fetchListOfCSM = useCallback(() => {
    getListOfCSM();
  }, [getListOfCSM]);

  const handleSearch = useCallback(val => {
    setSearch(val);
  }, []);

  useEffect(() => {
    fetchListOfCSM();
  }, [fetchListOfCSM]);

  const filteredList = useMemo(
    () =>
      search
        ? (
            listOfCSM ?? []
          ).filter(({ id, first_name: fName = '', last_name: lName = '', email = '' }) =>
            [fName, lName, id.toString(), email].some(value =>
              value.toLowerCase().includes(search.toLowerCase()),
            ),
          )
        : listOfCSM,
    [listOfCSM, search],
  );

  return (
    <Container>
      <FlexView alignItems="center" justifyContent="space-between" flexDirection="row">
        {listOfCSM?.length > 0 ? (
          <Text variant="h6">{`${listOfCSM.length} CSMs`}</Text>
        ) : null}
        <Search
          showNewSearchBar={true}
          onSearch={handleSearch}
          placeholder="Search CSM by name, email & ID"
        />
      </FlexView>
      <TableWrapper>
        <Table
          headerCell={[
            { title: 'Name' },
            { title: 'Email' },
            { title: 'Parents' },
            { title: 'Teachers' },
          ]}
          dataLength={listOfCSM?.length || 0}
          havePagination
          showInfo={false}
          showLoader={isLoading}
          flexBasis="100%"
        >
          {filteredList?.map(({ id, first_name = '', last_name = '', email }) => (
            <TableRow key={id}>
              <StyledTableCell
                width={4}
                onClick={() => window.open(`/users/csm/${id}`, '_blank')}
              >
                {getUserFullName(first_name, last_name)}
              </StyledTableCell>
              <TableCell width={4}>
                <Text variant="body2">{email}</Text>
              </TableCell>
              <StyledTableCell
                onClick={() =>
                  window.open(`/users/csm/${id}?activeTab=parents`, '_blank')
                }
              >
                See Parents
              </StyledTableCell>
              <StyledTableCell
                onClick={() =>
                  window.open(`/users/csm/${id}?activeTab=teachers`, '_blank')
                }
              >
                See Teachers
              </StyledTableCell>
            </TableRow>
          ))}
        </Table>
      </TableWrapper>
      <Separator transparent height={8} />
    </Container>
  );
};

export default CSM;
